import React, { Children } from 'react';
import { motion } from 'framer-motion';
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.1,
      ease: [0.16, 1, 0.3, 1]
    }
  }
};
/**
 * Quiet editorial text breaker between the hero and the first content
 * section — sets the tone before the imagery resumes.
 */
export function IntroBreaker() {
  return <section className="w-full bg-bg-warm px-6 md:px-14 py-20 md:py-36 relative z-10" data-id="element-105">
      <motion.div initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} variants={{
      visible: {
        transition: {
          staggerChildren: 0.15
        }
      }
    }} className="max-w-4xl mx-auto text-center" data-id="element-106">
        <motion.h2 variants={fadeUp} className="font-heading text-3xl md:text-6xl font-light tracking-tight text-primary leading-[1.1]" data-id="element-107">
          Your future home awaits.
        </motion.h2>
        <motion.p variants={fadeUp} className="mt-6 md:mt-8 text-lg md:text-2xl font-light leading-relaxed text-text-muted max-w-3xl mx-auto" data-id="element-108">
          Campanilla is a 610 sqm residence in Ayala Westgrove Heights, designed
          for natural light, seamless flow, and unobstructed views, transforming
          your everyday into living art.
        </motion.p>
      </motion.div>
    </section>;
}